import * as types from './types';

export default {
  /**
   * Mutation to update the store with the fetched campaigns.
   *
   * @param {Object} state      The current state of the store.
   * @param {Array}  campaigns      The fetched campaigns.
   * @param {Object} pagination The fetched pagination.
   */
  [types.SET_MASKS](state, masks) {
    // eslint-disable-next-line no-param-reassign
    state.masks = masks;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/masks/mutations.js